<template>
	<v-card>
		<v-card-title>
			<span class="headline">مشخصات درخواست وام</span>
			<v-spacer />
			<v-btn @click="close" icon>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<v-container fluid>
				<div>
					<v-row>
						<v-col cols="12" md="3">
							<member-profile-header :data="localData.memberModel" :showEdit="false" :loading="loading" :showManageLoans="false" area="sponsor" />
						</v-col>
						<v-col cols="12" md="9" class="pt-5">
							<v-card class="mb-3" style="background-color: whitesmoke;">
								<v-progress-linear v-if="loading" class="mt-3" color="primary" height="4" indeterminate rounded></v-progress-linear>
								<v-form ref="form" v-else class="mx-2" lazy-validation>
									<v-row class="mb-2" style="margin: -9px; background-color: #eee;border-bottom: 1px dashed grey;border-top-left-radius: 10px;border-top-right-radius: 10px;">
										<v-col cols="12" class="text-center" style="">
											جزئیات درخواست
										</v-col>
									</v-row>
									<v-row class="mb-2">
										<v-col cols="12" md="6" class="pt-2">
											<label>نام طرح وام:</label>
											<span class="grey--text mr-1">{{ localData.loanModel.title }}</span>
										</v-col>
										<v-col cols="12" md="6" class="pt-2">
											<label>تاریخ درخواست:</label>
											<span class="grey--text mr-1">{{ localData.requestDate_Persian.date }}</span>
										</v-col>
										<v-col cols="12" md="3" class="py-0">
											<label>مبلغ:</label>
											<span class="grey--text mr-1">{{ String(localData.amount).toPriceFormat() }}</span>
											<small class="grey--text mr-1">تومان</small>
										</v-col>
										<v-col cols="12" md="2" class="py-0">
											<label>تعداد اقساط:</label>
											<span class="grey--text mr-1">{{ localData.installmentCount }}</span>
										</v-col>
										<v-col cols="12" md="3" class="py-0">
											<label>فاصله بین هر قسط:</label>
											<span class="grey--text mr-1">{{ localData.monthGap }}</span>
										</v-col>
										<v-col cols="12" md="4" class="py-0">
											<label>مبلغ هر قسط:</label>
											<span class="grey--text mr-1">{{ String(localData.installment).toPriceFormat() }}</span>
											<small class="grey--text mr-1">تومان</small>
										</v-col>
									</v-row>
									<v-row>
										<v-col cols="12" class="pb-0">
											<v-row class="mx-0">
												<v-col cols="3" class="px-0 py-0 text-left">
													نظر کارشناس (جهت ادمین):
												</v-col>
												<v-col cols="9" class="pl-0 py-0">
													<v-textarea rows="2" dense v-model="localData.adminDescriptionPrivate" outlined :error-messages="errorMessages" />
												</v-col>
											</v-row>
											<v-row class="mx-0">
												<v-col cols="3" class="px-0 py-0 text-left">
													نظر کارشناس (جهت مشتری):
												</v-col>
												<v-col cols="9" class="pl-0 py-0">
													<v-textarea rows="2" dense v-model="localData.adminDescription" outlined :error-messages="errorMessages" />
												</v-col>
											</v-row>
										</v-col>
									</v-row>
									<div class="text-left mt-2">
										<v-btn class="mb-3 mr-2" v-if="!!localData.userLoan.code" @click="showUserLoanDetail" outlined color="secondary">
											{{ `وام شماره ${localData.userLoan.code}` }} - مشاهده پرونده
										</v-btn>
										<v-btn class="mb-3 mr-2" v-else color="secondary" dark @click="createUserLoanClick()">
											تبدیل به وام
										</v-btn>
									</div>
								</v-form>
							</v-card>
							<v-card class="mb-3 mt-6" style="background-color: whitesmoke;" v-if="!loading && checkActivePart('sponsor')">
								<div class="text-center mb-6 py-2" style="background-color: #eee;border-bottom: 1px dashed grey;border-top-left-radius: 10px;border-top-right-radius: 10px;">
									مدیریت اسپانسر
								</div>
								<v-row class="mx-0">
									<v-col cols="3" class="px-0 text-left">
										وضعیت جاری درخواست:
									</v-col>
									<v-col cols="9" class="d-flex">
										<span class="grey--text">{{statuses.findIndex(x => x.id === localData.userLoanSponsorStatus) > -1 ? statuses.find(x => x.id === localData.userLoanSponsorStatus).title : '-'}}</span>
										<v-btn small color="secondary" class="mr-2" @click="showNewHistory(0)">تغییر وضعیت</v-btn>
									</v-col>
								</v-row>
								<v-row class="mx-0">
									<v-col cols="3" class="px-0 text-left">
										آخرین توضیحات اسپانسر:
									</v-col>
									<v-col cols="9" class="">
										<p style="border:1px solid grey;border-radius: 5px;min-height: 60px;white-space: pre-line;" class="ma-0 pa-2">
											{{ localData.lastSponsorComment }}
										</p>
										<v-btn small color="secondary" class="mt-2" @click="showNewHistory(1)">ثبت توضیحات جدید</v-btn>
									</v-col>
								</v-row>
								<div class="px-3 mt-3">
									<v-alert type="info" outlined class="mb-1" v-if="!sponsorHistoryList.length">تاریخچه تغییرات خالی است.</v-alert>
									<div v-else>
										<div v-if="sponsorHistoryLoading">
											<v-progress-linear class="mt-3" color="primary" height="4" indeterminate rounded></v-progress-linear>
											<v-alert type="warning" icon="mdi-timer-sand" outlined>
												در حال دریافت تاریخچه تغییرات...
											</v-alert>
										</div>
										<v-divider class=""></v-divider>
										<div class="my-2 text-center">تاریخچه تغییرات:</div>
										<v-card elevation="1" class="pa-2 mb-3" color="white" v-for="history in sponsorHistoryList" :key="history.id">
											<v-row class="my-0">
												<v-col cols="12" sm="4" class="d-flex py-0">
													<v-icon color="success" small class="ml-">mdi-calendar</v-icon>
													<small class="ml-1">تاریخ و ساعت:</small>
													<small class="grey--text">&lrm;{{ history.dateTime_Persian.date }} {{ history.dateTime_Persian.time }}</small>
												</v-col>
												<v-col cols="12" sm="4" class="d-flex py-0">
													<v-icon color="success" small class="ml-">mdi-account</v-icon>
													<small class="ml-1">توسط:</small>
													<small class="grey--text">{{ history.user.fullName }}</small>
												</v-col>
												<v-col cols="12" sm="4" class="d-flex py-0">
													<v-icon color="success" small class="ml-">mdi-leaf</v-icon>
													<small class="ml-1">موضوع:</small>
													<small class="grey--text">{{ history.subject }}</small>
												</v-col>
												<v-col cols="12" sm="12" class="d-flex py-0">
													<small class="ml-1">شرح:</small>
													<p class="text-justify ma-0" style="white-space: pre-line;">
														<small class="grey--text">{{ history.description }}</small>
													</p>
												</v-col>
											</v-row>
										</v-card>
									</div>
								</div>
							</v-card>
							<div class="">
								<div class="text-h3 grey--text my-2">مدارک:</div>
								<div v-if="authorizeStepLoading" class="success--text text-h4 text-center">
									در حال دریافت اطلاعات ...
								</div>
								<v-alert type="success" outlined class="mb-1" v-if="authorizationItems.length === 0 && !authorizeStepLoading">وام دارای مدارک نمی باشد.</v-alert>
								<v-row class="mt-2 justify-center">
									<v-col cols="12" sm="12" md="11" class="px-5" v-for="(auth, index) in authorizationItems" :key="auth.id + auth.status">
										<v-card class="mb-4" elevation="4">
											<div class="text-center text-h4 white--text pa-2 grey" style="border-top-left-radius: 10px; border-top-right-radius: 10px">
												{{ auth.authorizationItem.title }}
											</div>
											<div class="pa-3">
												<div class="text-center" style="border-bottom: 1px dashed #ddd;white-space: pre-line;" v-if="auth.authorizationItem.description && ![5, 6].includes(auth.authorizationItem.systemType)" v-html="replaceToLink(auth.authorizationItem.description)">
												</div>
												<v-row class="mt-2">
													<v-col v-if="auth.authorizationItem.systemType === 1" cols="12" md="12" class="text-center">
														<IceManager :isAdmin="true" :userId="localData.memberModel.id" :isSummery="false" />
													</v-col>
													<v-col v-if="auth.authorizationItem.systemType === 2" cols="12" md="12" class="text-center">
														<IranValidityManager :isAdmin="true" :userId="localData.memberModel.id" :isSummery="false" />
													</v-col>
													<v-col v-if="auth.authorizationItem.systemType === 4" cols="12" md="9" class="text-center">
														<RefahAuthorizationItem :data="auth.memberDescription" />
													</v-col>
													<v-col v-if="[5, 6].includes(auth.authorizationItem.systemType)" cols="12" md="9" class="text-center">
														<v-row v-for="(attachment, index) in auth.attachments.filter(x => x.rowState !== 'deleted')" :key="attachment.id + index" style="border-bottom: 1px dashed #ccc;">
															<v-col cols="12" md="3">
																<ImageUploader style="width: 120px;" :ref="'imageUploader' + auth.id + index" :editable="checkIsEditable(auth.status)" v-model="attachment.base64" :fileUrl="attachment.fileUrl" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(attachment.base64)" @delete="() => attachment.attachment = ''" />
															</v-col>
															<v-col cols="12" md="9">
																<DigitalSignContract :auth="auth" area="sponsor" @updated="reloadAuthorizeItem(auth.id)" />
															</v-col>
														</v-row>
													</v-col>
													<v-col v-if="auth.authorizationItem.systemType === 0" cols="12" md="12" class="pb-0 text-center">
														<v-row v-for="(attachment, index) in auth.attachments.filter(x => x.rowState !== 'deleted')" :key="attachment.id + index" style="border-bottom: 1px dashed #ccc;">
															<v-col cols="12" md="3">
																<ImageUploader :ref="'imageUploader' + auth.id + index" :downloadFileName="auth.authorizationItem.title + '-' + localData.memberModel.fullName" :downloadable="true" :editable="attachment.attachmentByAdmin || !attachment.attachment" v-model="attachment.base64" :fileUrl="attachment.fileUrl" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(attachment.base64)" @delete="() => attachment.attachment = ''" />
															</v-col>
															<v-col cols="12" md="9" class="text-right">
																<div>توضیحات مشتری:</div>
																<div class="grey--text" style="border-bottom: 1px dashed grey;padding-bottom: 5px;">
																	<div v-if="attachment.memberDescription" style="white-space: pre-line;">
																		{{ attachment.memberDescription }}
																	</div>
																	<div v-else>
																		توضیحاتی ثبت نشده است
																	</div>
																</div>
															</v-col>
														</v-row>
													</v-col>
												</v-row>
											</div>
										</v-card>
									</v-col>
								</v-row>
							</div>
						</v-col>
					</v-row>

					<v-dialog v-model="extraDataDialog" scrollable persistent max-width="450px">
						<v-card>
							<v-card-title>
								<span class="headline">اطلاعات تکمیلی ثبت وام</span>
								<v-spacer />
								<v-btn @click="extraDataDialog = false" icon>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<v-container>
									<v-form ref="extraDataform" class="mx-2" lazy-validation @submit.prevent="validateNewUserLoan">
										<v-row>
											<v-col cols="12" md="12">
												<div class="d-flex mb-1">
													<span class="ml-2" style="width:120px">تاریخ شروع وام:</span>
													<date-picker ref="saveDate" v-model="localData.userLoan.startDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" />
												</div>
												<div class="red--text">
													{{ startDatePickerValidatioin }}
												</div>
											</v-col>
											<v-col cols="12" md="12" v-if="!localData.agentModel">
												<div class="d-flex mb-1">
													<span class="ml-2" style="width:120px">سررسید واریز به حساب مشتری:</span>
													<date-picker ref="depositChargeDueDate" v-model="localData.userLoan.depositChargeDueDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" />
												</div>
												<div class="red--text">
													{{ depositChargeDueDatePickerValidatioin }}
												</div>
											</v-col>
										</v-row>
										<v-card-actions class="pt-5">
											<v-spacer />
											<v-btn @click="extraDataDialog = false">
												بستن
											</v-btn>
											<v-btn color="blue" dark type="submit" :loading="loading">
												ایجاد وام
											</v-btn>
										</v-card-actions>
									</v-form>
								</v-container>
							</v-card-text>
						</v-card>
					</v-dialog>

					<v-dialog v-model="createHistoryDialog" scrollable persistent max-width="450px">
						<v-card>
							<v-card-title>
								<span class="headline">{{ createHistoryTitle }}</span>
								<v-spacer />
								<v-btn @click="createHistoryDialog = false" icon>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<v-container>
									<v-form ref="extraDataform" class="mx-2" lazy-validation @submit.prevent="submitNewHistory">
										<div v-if="newHistoryType === 0">
											<v-btn-toggle v-model="newStatus" dense tile outlined color="purple" class="mr-2 flex-wrap">
												<v-btn v-for="status in statuses" block :key="status.id" :value="status.id" class="rounded-xl mx-1 my-1">
													{{ status.title }}
												</v-btn>
											</v-btn-toggle>
										</div>
										<div v-else-if="newHistoryType === 1">
											<label>توضیحات خود را در باکس زیر وارد کنید:</label>
											<v-textarea rows="4" dense v-model="newComment" outlined :error-messages="errorMessages" :rules="[(val) => !!val || 'توضیحات را وارد کنید']" />
										</div>
										<v-divider class="mt-4"></v-divider>
										<v-card-actions class="pt-1">
											<v-spacer />
											<v-btn @click="createHistoryDialog = false">
												بستن
											</v-btn>
											<v-btn color="blue" dark type="submit" :loading="submitHistoryLoading">
												ذخیره
											</v-btn>
										</v-card-actions>
									</v-form>
								</v-container>
							</v-card-text>
						</v-card>
					</v-dialog>

					<v-dialog v-model="userLoanDetailDialog" scrollable persistent max-width="1500px">
						<v-card>
							<v-card-title>
								<span class="headline">اطلاعات پرونده</span>
								<v-spacer />
								<v-btn @click="userLoanDetailDialog = false" icon>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<UserLoanDetail :area="'sponsor'" :userLoanId="localData.userLoan.id" />
							</v-card-text>
						</v-card>
					</v-dialog>

					<confirm-dlg ref="confirm" />
				</div>
			</v-container>
		</v-card-text>
	</v-card>
</template>

<script>
	import api from '@/util/app-api'
	import { call, get } from 'vuex-pathify'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import MemberProfileHeader from '@/components/forms/MemberProfileHeader'
	import ImageUploader from '@/components/uploader/ImageUploader'
	import RefahAuthorizationItem from '@/components/RefahAuthorizationItem.vue'
	import { sponsorStatuses } from '@/util/enums'
	import DigitalSignContract from '@/components/loanAuthorizations/DigitalSignContract.vue'

	export default {
		name: 'SponsorModifyRequestView',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			AppSmsDetail: () => import('@/components/AppSmsDetails.vue'),
			'member-profile-header': MemberProfileHeader,
			ImageUploader,
			RefahAuthorizationItem,
			IceManager: () => import('@/components/loanAuthorizations/IceManager'),
			IranValidityManager: () => import('@/components/loanAuthorizations/IranValidityManager'),
			UserLoanDetail: () => import('@/components/forms/UserLoanDetail.vue'),
			'date-picker': () => import('vue-persian-datetime-picker'),
			DigitalSignContract,
		},
		data() {
			return {
				statusToggler: 0,
				loading: false,
				loading2: false,
				sponsorHistoryLoading: false,
				errorMessages: '',
				localData: { loanModel: {}, memberModel: null, requestDate_Persian: {}, userLoan: {}, sponsorHistoryCount: 0 },
				authorizationItems: [],
				overlayImgSrc: '',
				authorizeStepLoading: true,
				startDatePickerValidatioin: '',
				depositChargeDueDatePickerValidatioin: '',
				extraDataDialog: false,
				overlay: false,
				statusGroup: 0,
				sponsors: [],
				sponsorHistoryList: [],
				createHistoryTitle: '',
				createHistoryDialog: false,
				userLoanDetailDialog: false,
				newHistoryType: 0,
				submitHistoryLoading: false,
				newStatus: 0,
				newComment: '',
				statuses: sponsorStatuses,
			}
		},
		computed: {
			currentUser: get('auth/getCurrentUser'),
			isLocked() {
				return this.localData.lockedBy && this.localData.lockedBy.userId !== this.currentUser?.userData?.id
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadAuthorizationItems() {
				if (this.localData.id === emptyId)
					return

				this.authorizeStepLoading = true
				api.get('sponsor/UserLoanRequestAuthorizationItem/ListByUserLoanRequestId/' + this.localData.id, null)
					.then(response => {
						this.authorizationItems = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.authorizeStepLoading = false
					})
			},
			async submitSponsor() {
				if (!this.$refs.formSponsor.validate()) {
					toast.error('ابتدا موارد فرم اسپانسر را تکمیل نمایید')
					return
				}
				if (this.localData.id === emptyId) {
					toast.error('ابتدا درخواست وام را ذخیره سپس اقدام به تعیین اسپانسر نمایید.')
					return
				}
				var data = {
					userLoanRequestId: this.localData.id,
					sponsorId: this.localData.sponsorModel?.id
				}
				this.loading2 = true
				api.post('sponsor/userLoanRequest/submitSponsor', data)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(err => {
						this.loading2 = false
					})
			},
			loadData() {
				if (!this.data) {
					this.data = { id: emptyId }
				}
				if (!this.data.id) {
					this.data.id = emptyId
				}
				this.loading = true
				api.get('sponsor/userLoanRequest/get/' + this.data.id, null)
					.then(response => {
						this.localData = response
						if (this.data.id === emptyId) Object.assign(this.localData, this.data)
						// this.localData.status = { id: this.localData.status }
						this.localData.month = { id: this.localData.month }
						this.loadAuthorizationItems()
						this.localData.userLoan = this.localData.userLoan ? { id: this.localData.userLoan.id, code: this.localData.userLoan.code, agentDueDate_Persian: this.localData.userLoan.agentDueDate_Persian } : {}
						this.loadSponsorHistory()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			viewImage(img) {
				this.overlay = true
				this.overlayImgSrc = img
			},
			async createUserLoanClick() {
				if (!this.localData.installment) {
					toast.error('مبلغ قسط پر نشده است')
					return
				}

				this.localData.userLoan.startDate = ''
				this.localData.userLoan.depositChargeDueDate = null
				this.extraDataDialog = true
				//this.submitNewUserLoan()
			},
			validateNewUserLoan() {
				let isValid = true
				this.startDatePickerValidatioin = ''
				if (!this.localData.userLoan.startDate) {
					this.startDatePickerValidatioin = 'تاریخ شروع را وارد کنید'
					isValid = false
				}
				this.depositChargeDueDatePickerValidatioin = ''
				if (this.$refs.depositChargeDueDate && !this.localData.userLoan.depositChargeDueDate) {
					this.depositChargeDueDatePickerValidatioin = 'سررسید واریز به حساب مشتری را وارد کنید'
					isValid = false
				}
				if (isValid)
					this.submitNewUserLoan()
			},
			async submitNewUserLoan() {
				var data = {}
				Object.assign(data, this.localData)
				data.month = this.localData.month.id
				this.loading = true
				api.post('sponsor/userLoan/CreateByUserLoanRequest', data)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.$emit('callbck', true)
							this.extraDataDialog = false
							this.loadData()
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => this.loading = false)
			},
			replaceToLink(text) {
				if (!text)
					return ''
				return text.replace(
					/((http|https|ftp|ftps)\:\/\/[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g,
					'<a href="$1" target="_blank">$1</a>'
				)
			},
			close() {
				this.$emit('close')
			},
			loadSponsorHistory() {
				this.sponsorHistoryLoading = true
				api.get('sponsor/UserLoanRequestSponsorHistory/GetSponsorHistory?userLoanRequestId=' + this.localData.id, null)
					.then(response => {
						this.sponsorHistoryList = response
					})
					.catch(err => {
						toast.error('خطا در دریافت لیست تاریخچه تغییرات اسپانسر. ' + err.message)
					})
					.finally(err => {
						this.sponsorHistoryLoading = false
					})
			},
			showNewHistory(type) {
				this.newHistoryType = type
				this.createHistoryDialog = true
				this.createHistoryTitle = type === 0 ? 'تغییر وضعیت درخواست' : 'ثبت توضیحات'
				this.newStatus = this.localData.userLoanSponsorStatus
			},
			submitNewHistory() {
				this.submitHistoryLoading = true
				let data = {
					userLoanRequestId: this.localData.id,
					comment: this.newComment,
					status: this.newStatus,
					type: this.newHistoryType
				}
				api.post('sponsor/UserLoanRequestSponsorHistory/Create', data)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.createHistoryDialog = false
							if (this.newHistoryType === 0)
								this.localData.userLoanSponsorStatus = this.newStatus
							else if (this.newHistoryType === 1)
								this.localData.lastSponsorComment = this.newComment
							this.loadSponsorHistory()
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => this.submitHistoryLoading = false)
			},
			showUserLoanDetail() {
				this.userLoanDetailDialog = true
			},
			reloadAuthorizeItem(id) {
				this.submitAuthorizeItemLoading = id
				api.get('member/UserLoanRequestAuthorizationItem/get/' + id, {})
					.then(response => {
						let index = this.authorizationItems.findIndex(x => x.id === id)
						if (index > -1)
							this.authorizationItems.splice(index, 1, response)
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitAuthorizeItemLoading = '' })
			},
		}
	}
</script>

<style></style>
